/**
 * Theoric — Influencer Tracking & Coupon System
 *
 * Captura o parâmetro ?ref=CODE da URL, persiste o cupom em localStorage + cookie,
 * injeta UTMs automaticamente, e dispara eventos para GA4/GTM e N8N.
 *
 * Links esperados: https://theoric.com.br/?ref=MABERGO
 * O sistema mapeia o código da influenciadora para o cupom correto.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'theoric_influencer';
  var COOKIE_DAYS = 30;
  var COUPON_COOKIE = 'theoric_coupon';
  var UTM_COOKIE = 'utmsTrack';

  var BANNER_DURATION = 7000; // ms antes de sumir automaticamente
  var BANNER_COOLDOWN_HOURS = 6; // horas sem mostrar o banner após as 2 primeiras exibições

  /* ── Mapa de influenciadoras ──────────────────────────────────────────── */
  var INFLUENCER_MAP = {
    'MABERGO': { coupon: 'MABERGO', name: 'Mariana Bergo', ig: 'maabergo', offer: '15% OFF', expires_at: '2026-12-01' },
    'VERI': { coupon: 'VERI', name: 'Veridiana Magalhães', ig: 'veerimoreira', offer: '15% OFF', expires_at: '2026-12-01' },
    'BRUNA': { coupon: 'BRUNA', name: 'Bruna Rezende', ig: 'br.rezende', offer: '15% OFF', expires_at: '2026-12-01' },
    'MAJU': { coupon: 'MAJU', name: 'Maria Júlia Mazali', ig: 'majumazalli', offer: '15% OFF', expires_at: '2026-12-01' },
    'TALITA': { coupon: 'TALITA', name: 'Talita Oliveira', ig: 'talitaoliveiiira', offer: '15% OFF', expires_at: '2026-12-01' },
    'JOAO10': { coupon: 'JOAO10', name: 'João', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'BB10': { coupon: 'BB10', name: 'BB', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'GUI15': { coupon: 'GUI15', name: 'Gui', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'GABI15': { coupon: 'GABI15', name: 'Gabi', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'DUDA15': { coupon: 'DUDA15', name: 'Duda', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'GUALBERTO15': { coupon: 'GUALBERTO15', name: 'Gualberto', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'THIAGOMIGUEL15': { coupon: 'THIAGOMIGUEL15', name: 'Thiago Miguel', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'ARGUELES15': { coupon: 'ARGUELES15', name: 'Argueles', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'BERTUOL15': { coupon: 'BERTUOL15', name: 'Bertuol', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'ANAPAULA15': { coupon: 'ANAPAULA15', name: 'Ana Paula', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'JEAN15': { coupon: 'JEAN15', name: 'Jean', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'LIVIA15': { coupon: 'LIVIA15', name: 'Livia', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'DEBI15': { coupon: 'DEBI15', name: 'Debi', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MAY15': { coupon: 'MAY15', name: 'May', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'LUMA15': { coupon: 'LUMA15', name: 'Luma', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MARIALETICIA15': { coupon: 'MARIALETICIA15', name: 'Maria Leticia', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MARCELA15': { coupon: 'MARCELA15', name: 'Marcela', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'FLAVIA15': { coupon: 'FLAVIA15', name: 'Flavia', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'KALI15': { coupon: 'KALI15', name: 'Kali', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'GABIFERNANDES15': { coupon: 'GABIFERNANDES15', name: 'Gabi Fernandes', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'JESSICA15': { coupon: 'JESSICA15', name: 'Jessica', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'VIVI15': { coupon: 'VIVI15', name: 'Vivi Orth', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'AGATHA15': { coupon: 'AGATHA15', name: 'Agatha', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'VANESSA15': { coupon: 'VANESSA15', name: 'Vanessa', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'ISASIMOES15': { coupon: 'ISASIMOES15', name: 'Isa Simoes', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'SANDY15': { coupon: 'SANDY15', name: 'Sandy', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'CINTHIA15': { coupon: 'CINTHIA15', name: 'Cinthia', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'NEMVEM15': { coupon: 'NEMVEM15', name: 'Nemvem', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'JESSY15': { coupon: 'JESSY15', name: 'Jessy', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'BFF15': { coupon: 'BFF15', name: 'BFF', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'RACHEL15': { coupon: 'RACHEL15', name: 'Rachel', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'ANACECILIA15': { coupon: 'ANACECILIA15', name: 'Ana Cecilia', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'FRAN15': { coupon: 'FRAN15', name: 'Fran Rodrigues', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'ISASOOS15': { coupon: 'ISASOOS15', name: 'Isabella Soos', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MARIE15': { coupon: 'MARIE15', name: 'Marie Raya', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'NATHVALINO15': { coupon: 'NATHVALINO15', name: 'Nathalia Valino', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'RAFABORGES15': { coupon: 'RAFABORGES15', name: 'Rafaela Borges', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'THAISHORST15': { coupon: 'THAISHORST15', name: 'Thais Horst', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'ANDRESSA15': { coupon: 'ANDRESSA15', name: 'Andressa', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'KETH15': { coupon: 'KETH15', name: 'Keth', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'DANA15': { coupon: 'DANA15', name: 'Dana', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'VAL15': { coupon: 'VAL15', name: 'Val', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'KEZZIA15': { coupon: 'KEZZIA15', name: 'Kezzia', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'JOSEH15': { coupon: 'JOSEH15', name: 'Jose H', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'DONI15': { coupon: 'DONI15', name: 'Doni', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'SIMAS15': { coupon: 'SIMAS15', name: 'Rodrigo Simas', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'FIFI15': { coupon: 'FIFI15', name: 'Fifi', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MACARRASCO15': { coupon: 'MACARRASCO15', name: 'Ma Carrasco', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'ANAVILELA15': { coupon: 'ANAVILELA15', name: 'Ana Vilela', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'LEOBARRETO15': { coupon: 'LEOBARRETO15', name: 'Leo Barreto', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'ISAMARINS15': { coupon: 'ISAMARINS15', name: 'Isa Marins', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'CAROLBASSI15': { coupon: 'CAROLBASSI15', name: 'Carol Bassi', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'BIANCALOPES15': { coupon: 'BIANCALOPES15', name: 'Bianca Lopes', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'LUBROZZO15': { coupon: 'LUBROZZO15', name: 'Lu Brozzo', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'RAIZER15': { coupon: 'RAIZER15', name: 'Raizer', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MONIKA15': { coupon: 'MONIKA15', name: 'Monika', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'SASKYA15': { coupon: 'SASKYA15', name: 'Saskya', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'KURTZ15': { coupon: 'KURTZ15', name: 'Kurtz', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'VARGAS15': { coupon: 'VARGAS15', name: 'Vargas', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'XAVIER15': { coupon: 'XAVIER15', name: 'Xavier', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'WESLEY15': { coupon: 'WESLEY15', name: 'Wesley', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'VV15': { coupon: 'VV15', name: 'Vivi', ig: '', offer: '15% OFF', expires_at: '2026-12-01'},
    'DEBORAH15': { coupon: 'DEBORAH15', name: 'Deborah', ig: '', offer: '15% OFF', expires_at: '2026-12-01'},
    'LUIZALAWISCH15': { coupon: 'LuizaLawisch15', name: 'Luiza Lawisch', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'LUALVARENGA15': { coupon: 'LuAlvarenga15', name: 'Lu Alvarenga', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'ANASAAR15': { coupon: 'AnaSaar15', name: 'Ana Saar', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'PAGGI15': { coupon: 'Paggi15', name: 'Paggi', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'GAZETA15': { coupon: 'Gazeta15', name: 'Gazeta', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'NATHALY15': { coupon: 'Nathaly15', name: 'Nathaly', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'JANA15': { coupon: 'Jana15', name: 'Jana', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'RAUPP15': { coupon: 'Raupp15', name: 'Raupp', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'GIGIDARIENZO15': { coupon: 'Gigidarienzo15', name: 'Gigi D\'Arienzo', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'JUNALDER15': { coupon: 'JuNalder15', name: 'Ju Nalder', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'GIFERRAREZI15': { coupon: 'GiFerrarezi15', name: 'Gi Ferrarezi', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'IGUITA15': { coupon: 'Iguita15', name: 'Iguita', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'ANAARANTES15': { coupon: 'AnaArantes15', name: 'Ana Arantes', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'VINCENZO15': { coupon: 'Vincenzo15', name: 'Vincenzo', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'GUTABASTOS15': { coupon: 'GUTABASTOS15', name: 'Guta Bastos', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MELISSAGARCIA15': { coupon: 'MELISSAGARCIA15', name: 'Melissa Garcia', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'JULIAVITORINO15': { coupon: 'JULIAVITORINO15', name: 'Julia Vitorino', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'NAGILAVIEIRA15': { coupon: 'NAGILAVIEIRA15', name: 'Nagila Vieira', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'TATIRIGOTTI15': { coupon: 'TATIRIGOTTI15', name: 'Tati Rigotti', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'DHIOVANASOUZA15': { coupon: 'DHIOVANASOUZA15', name: 'Dhiovana Souza', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MARIABLANCO15': { coupon: 'MARIABLANCO15', name: 'Maria Blanco', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'BARBETO15': { coupon: 'BARBETO15', name: 'Barbeto', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MANOCALGAROTO15': { coupon: 'MANOCALGAROTO15', name: 'Mano Cal Garoto', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'CLARAMAKEUP15': { coupon: 'CLARAMAKEUP15', name: 'Clara Makeup', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'WALESKAMOURA15': { coupon: 'WALESKAMOURA15', name: 'Waleska Moura', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'NICOLLIBORBA15': { coupon: 'NICOLLIBORBA15', name: 'Nicolli Borba', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MELINDABERNSTORFF15': { coupon: 'MELINDABERNSTORFF15', name: 'Melinda Bernstorff', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'LORENAMALINOVSKI15': { coupon: 'LORENAMALINOVSKI15', name: 'Lorena Malinovski', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'BRUNALIMA15': { coupon: 'BRUNALIMA15', name: 'Bruna Lima', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'THALES15': { coupon: 'THALES15', name: 'Thales', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'CHLOE15': { coupon: 'CHLOE15', name: 'Chloe', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'GUIGINO15': { coupon: 'GUIGINO15', name: 'Guilherme Gino', ig: '', offer: '15% OFF', expires_at: '2026-12-01'},
    'MARS15': { coupon: 'MARS15', name: 'Mars', ig: '', offer: '15% OFF', expires_at: '2026-12-01'},
    'THON15': { coupon: 'THON15', name: 'Thon Coelho', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'AMANDAPAGGI15': { coupon: 'AMANDAPAGGI15', name: 'Amanda Paggi', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MARIANDRADE15': { coupon: 'MARIANDRADE15', name: 'Mari Andrade', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'ISA15': { coupon: 'ISA15', name: 'Isabella Devidé', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'BRUGONÇALVES15': { coupon: 'BRUGONÇALVES15', name: 'Bru Gonçalves', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'JESSICAYUMI15': { coupon: 'JESSICAYUMI15', name: 'Jessica Yumi', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'CRISALLACCUA15': { coupon: 'CRISALLACCUA15', name: 'Cris Allaccua', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'JESSICAGOMES15': { coupon: 'JESSICAGOMES15', name: 'Jessica Gomes', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'TAMIRISADM15': { coupon: 'TAMIRISADM15', name: 'Tamiris ADM', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'THALITAOLIVEIRA15': { coupon: 'THALITAOLIVEIRA15', name: 'Thalita Oliveira', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MARIAEDUARDAP15': { coupon: 'MARIAEDUARDAP15', name: 'Maria Eduarda P', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'EVELICOLARES15': { coupon: 'EVELICOLARES15', name: 'Eveli Colares', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'LETICIACALISTO15': { coupon: 'LETICIACALISTO15', name: 'Leticia Calisto', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'LIBIAGARCIA15': { coupon: 'LIBIAGARCIA15', name: 'Libia Garcia', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MIRELLACABRAL15': { coupon: 'MIRELLACABRAL15', name: 'Mirella Cabral', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'ANALUCIADIAS15': { coupon: 'ANALUCIADIAS15', name: 'Ana Lucia Dias', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MYRELAPONTES15': { coupon: 'MYRELAPONTES15', name: 'Myrela Pontes', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'GABRIELAMARIA15': { coupon: 'GABRIELAMARIA15', name: 'Gabriela Maria', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'SUZANAPASSOLD15': { coupon: 'SUZANAPASSOLD15', name: 'Suzana Passold', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'GRECIAROQUE15': { coupon: 'GRECIAROQUE15', name: 'Grecia Roque', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'KARMEL15': { coupon: 'KARMEL15', name: 'Karmel', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MARIALUIZAA15': { coupon: 'MARIALUIZAA15', name: 'Maria Luiza A', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'KIARAYUMI15': { coupon: 'KIARAYUMI15', name: 'Kiara Yumi', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'BARBARAKOHLS15': { coupon: 'BARBARAKOHLS15', name: 'Barbara Kohls', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'JHEYGREMMIE15': { coupon: 'JHEYGREMMIE15', name: 'Jhey Gremmie', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'ROHMIRANDA15': { coupon: 'ROHMIRANDA15', name: 'Roh Miranda', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'BRUNAMATTER15': { coupon: 'BRUNAMATTER15', name: 'Bruna Matter', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'YASMINTOZZI15': { coupon: 'YASMINTOZZI15', name: 'Yasmin Tozzi', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'JESKARAUJO15': { coupon: 'JESKARAUJO15', name: 'Jeska Raujo', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'LAURAGARBIN15': { coupon: 'LAURAGARBIN15', name: 'Laura Garbin', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'PAOLASEGRETO15': { coupon: 'PAOLASEGRETO15', name: 'Paola Segreto', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'GIOVANAVILAÇA15': { coupon: 'GIOVANAVILAÇA15', name: 'Giovana Vilaça', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'SARACICHILERO15': { coupon: 'SARACICHILERO15', name: 'Sara Cichilero', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'GLORIALUISE15': { coupon: 'GLORIALUISE15', name: 'Gloria Luise', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'STEFANIMENEGAZ15': { coupon: 'STEFANIMENEGAZ15', name: 'Stefani Menegaz', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'LARISSALOPESMRS15': { coupon: 'LARISSALOPESMRS15', name: 'Larissa Lopes MRS', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'RAISSAPRADO15': { coupon: 'RAISSAPRADO15', name: 'Raissa Prado', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'CRISACCUA15': { coupon: 'CRISACCUA15', name: 'Cris Accua', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'JULIANADIORIO15': { coupon: 'JULIANADIORIO15', name: 'Juliana Diorio', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MARIACAROLINAB15': { coupon: 'MARIACAROLINAB15', name: 'Maria Carolina B', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'ISABELLAFRANCO15': { coupon: 'ISABELLAFRANCO15', name: 'Isabella Franco', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'PRISCILAKIESKI15': { coupon: 'PRISCILAKIESKI15', name: 'Priscila Kieski', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'REBECCALIMA15': { coupon: 'REBECCALIMA15', name: 'Rebecca Lima', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'CAMILATOIGO15': { coupon: 'CAMILATOIGO15', name: 'Camila Toigo', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'NATALIECALDEIRA15': { coupon: 'NATALIECALDEIRA15', name: 'Natalie Caldeira', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MILENAADANS15': { coupon: 'MILENAADANS15', name: 'Milena Adans', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'BRUNAMONTEIRO15': { coupon: 'BRUNAMONTEIRO15', name: 'Bruna Monteiro', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'TAYNAIZIQUIEL15': { coupon: 'TAYNAIZIQUIEL15', name: 'Tayna Iziquiel', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'NATALIAAA15': { coupon: 'NATALIAAA15', name: 'Nataliaaa', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'BARBRAALIANE15': { coupon: 'BARBRAALIANE15', name: 'Barbra Aliane', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MAIRAGALVAO15': { coupon: 'MAIRAGALVAO15', name: 'Maira Galvao', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'KAROLMENDES15': { coupon: 'KAROLMENDES15', name: 'Karol Mendes', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MARINAGARCEZ15': { coupon: 'MARINAGARCEZ15', name: 'Marina Garcez', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'LETICIAESPAGNOLI15': { coupon: 'LETICIAESPAGNOLI15', name: 'Leticia Espagnoli', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'BEATRIZPROENÇA15': { coupon: 'BEATRIZPROENÇA15', name: 'Beatriz Proença', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'JULIAKOERNER15': { coupon: 'JULIAKOERNER15', name: 'Julia Koerner', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'LUANASILVEIRA15': { coupon: 'LUANASILVEIRA15', name: 'Luana Silveira', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'LARISSAANDRADE15': { coupon: 'LARISSAANDRADE15', name: 'Larissa Andrade', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'RAFAELANASCIMENTO15': { coupon: 'RAFAELANASCIMENTO15', name: 'Rafaela Nascimento', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MÁRCIAVERMOHLEN15': { coupon: 'MÁRCIAVERMOHLEN15', name: 'Márcia Vermohlen', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'YALLELITWAK15': { coupon: 'YALLELITWAK15', name: 'Yalle Litwak', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'NATHALIATHIEL15': { coupon: 'NATHALIATHIEL15', name: 'Nathalia Thiel', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'ELLENSANAJIOTTO15': { coupon: 'ELLENSANAJIOTTO15', name: 'Ellen Sanajiotto', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'BIANCADAMBROS15': { coupon: 'BIANCADAMBROS15', name: "Bianca D'Ambros", ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'LUANARODRIGUES15': { coupon: 'LUANARODRIGUES15', name: 'Luana Rodrigues', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'LETICIABENJAMIN15': { coupon: 'LETICIABENJAMIN15', name: 'Leticia Benjamin', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MICHELLEDASILVA15': { coupon: 'MICHELLEDASILVA15', name: 'Michelle da Silva', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'CIBELLYMACHADO15': { coupon: 'CIBELLYMACHADO15', name: 'Cibelly Machado', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'LAIZVIEIRA15': { coupon: 'LAIZVIEIRA15', name: 'Laiz Vieira', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'SABRINACORREA15': { coupon: 'SABRINACORREA15', name: 'Sabrina Correa', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'NATHALIASÁ15': { coupon: 'NATHALIASÁ15', name: 'Nathalia Sá', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'NATALIAGUIMARÃES15': { coupon: 'NATALIAGUIMARÃES15', name: 'Natalia Guimarães', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MILENAAGUIAR15': { coupon: 'MILENAAGUIAR15', name: 'Milena Aguiar', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'NEVIN15': { coupon: 'NEVIN15', name: 'Nevin', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'GI15': { coupon: 'GI15', name: 'Gi', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'ANAPAULAMENDES15': { coupon: 'ANAPAULAMENDES15', name: 'Ana Paula Mendes', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'MIMARQUES15': { coupon: 'MIMARQUES15', name: 'Mi Marques', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'GAB15': { coupon: 'GAB15', name: 'Gab', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },
    'PARCERIA20': { coupon: 'PARCERIA20', name: 'Parceria', ig: '', offer: '15% OFF', expires_at: '2026-12-01' },

    /* Cupons ativos sincronizados com Cupons_Adicionados.xlsx (sem data de termino). */
    'BEMVINDO10': { coupon: 'BEMVINDO10', name: 'Boas-vindas', ig: '', offer: '15% OFF', expires_at: '' },
    'TEST': { coupon: 'TEST', name: 'Test', ig: '', offer: '15% OFF', expires_at: '' },
    'REMEIRELLES15': { coupon: 'REMEIRELLES15', name: 'Re Meirelles', ig: '', offer: '15% OFF', expires_at: '' },
    'THATILACRIS15': { coupon: 'THATILACRIS15', name: 'Thatila Cris', ig: '', offer: '15% OFF', expires_at: '' },
    'XFAGNER15': { coupon: 'XFAGNER15', name: 'X Fagner', ig: '', offer: '15% OFF', expires_at: '' },
    'FELIPEBARBOZA15': { coupon: 'felipebarboza15', name: 'Felipe Barboza', ig: '', offer: '15% OFF', expires_at: '' },
    'VINICIUSLEITE15': { coupon: 'viniciusleite15', name: 'Vinicius Leite', ig: '', offer: '15% OFF', expires_at: '' },
    'NATALIGUIMARÃES15': { coupon: 'NataliGuimarães15', name: 'Natali Guimarães', ig: '', offer: '15% OFF', expires_at: '' },
    'YALLE15': { coupon: 'Yalle15', name: 'Yalle', ig: '', offer: '15% OFF', expires_at: '' },
    'CUPOM20': { coupon: 'CUPOM20', name: 'Cupom 20', ig: '', offer: '15% OFF', expires_at: '' },
    'MUITOTESTE': { coupon: 'MUITOTESTE', name: 'Muito Teste', ig: '', offer: '15% OFF', expires_at: '' },
    'BRUNA15': { coupon: 'BRUNA15', name: 'Bruna', ig: '', offer: '15% OFF', expires_at: '' },
    'BB15': { coupon: 'BB15', name: 'BB', ig: '', offer: '15% OFF', expires_at: '' },
    'TESTES': { coupon: 'TESTES', name: 'Testes', ig: '', offer: '15% OFF', expires_at: '' },
    'FRETETESTE12': { coupon: 'FRETETESTE12', name: 'Frete Teste', ig: '', offer: '15% OFF', expires_at: '' },
    'LISTAVIP': { coupon: 'LISTAVIP', name: 'Lista VIP', ig: '', offer: '15% OFF', expires_at: '' },
    '100ERIC': { coupon: '100ERIC', name: 'Eric', ig: '', offer: '15% OFF', expires_at: '' },
    'COTHEORIC35OFF': { coupon: 'COTHEORIC35OFF', name: 'CO Theoric', ig: '', offer: '15% OFF', expires_at: '' },
    'TESTE': { coupon: 'TEste', name: 'Teste', ig: '', offer: '15% OFF', expires_at: '' },
    /* A vigencia do CELEBRE10 vem do desconto no admin (Descontos -> CELEBRE10),
       espelhada em snippets/theoric-first-purchase-discount.liquid - nao do
       metaobjeto promocao (esse acoplamento caiu em 21/08/2026). Este cadastro
       so preserva a atribuicao/prioridade do codigo DIGITADO; ele nao aplica
       cupom nenhum, e por isso continua valendo mesmo com a ativacao
       automatica desligada. */
    'CELEBRE10': { coupon: 'CELEBRE10', name: 'Celebre', ig: '', offer: '10% OFF' },
    'MINHABOLSA': { coupon: 'MINHABOLSA', name: 'Minha Bolsa', ig: '', offer: '12% OFF', expires_at: '' },
    'MINHAROTINA': { coupon: 'MINHAROTINA', name: 'Minha Rotina', ig: '', offer: '15% OFF', expires_at: '' },
    'WESLEYCOELHO15': { coupon: 'WESLEYCOELHO15', name: 'Wesley Coelho', ig: '', offer: '15% OFF', expires_at: '' },
    'TESTE6': { coupon: 'TEste6', name: 'Teste 6', ig: '', offer: '15% OFF', expires_at: '' },
    'GUTABATOS15': { coupon: 'GUTABATOS15', name: 'Guta Batos', ig: '', offer: '15% OFF', expires_at: '' },
    'LORENAMALI15': { coupon: 'LORENAMALI15', name: 'Lorena Mali', ig: '', offer: '15% OFF', expires_at: '' },
    'BORBA15': { coupon: 'BORBA15', name: 'Borba', ig: '', offer: '15% OFF', expires_at: '' },
    'VITORINO15': { coupon: 'VITORINO15', name: 'Vitorino', ig: '', offer: '15% OFF', expires_at: '' },
    'MELINDAB15': { coupon: 'MELINDAB15', name: 'Melinda B', ig: '', offer: '15% OFF', expires_at: '' },
    'CLARAM15': { coupon: 'CLARAM15', name: 'Clara M', ig: '', offer: '15% OFF', expires_at: '' },
    'MEUKIT': { coupon: 'MEUKIT', name: 'Meu Kit', ig: '', offer: '15% OFF', expires_at: '' },
    'TESTESTESTESTESTESTESTESTESTESTESTES': { coupon: 'TESTESTESTESTESTESTESTESTESTESTESTES', name: 'Teste', ig: '', offer: '15% OFF', expires_at: '' },
    'TERSTE': { coupon: 'TERSTE', name: 'Terste', ig: '', offer: '15% OFF', expires_at: '' },
    'TESRS': { coupon: 'TESRS', name: 'Tesrs', ig: '', offer: '15% OFF', expires_at: '' },
    'CRA': { coupon: 'Cra', name: 'Cra', ig: '', offer: '15% OFF', expires_at: '' },
    'MUITODESCONTOFF': { coupon: 'MUITODESCONTOFF', name: 'Muito Desconto', ig: '', offer: '15% OFF', expires_at: '' },

    /* Calendario sazonal: fim exclusivo para manter o ultimo dia inteiro ativo. */
    'MICELLAR20': { coupon: 'MICELLAR20', name: 'The Micellar Milk', ig: '', offer: '20% OFF', starts_at: '2026-08-25T00:01:01-03:00', expires_at: '2026-08-30T23:59:59-03:00' },
    'SÉRUM20': { coupon: 'SÉRUM20', name: 'The Classic Triple Serum', ig: '', offer: '20% OFF', starts_at: '2026-08-03T00:00:00-03:00', expires_at: '2026-08-10T00:00:00-03:00' },
    'BALM20': { coupon: 'BALM20', name: 'The Multi-Use Nourishing Balm', ig: '', offer: '20% OFF', starts_at: '2026-08-10T00:00:00-03:00', expires_at: '2026-08-17T00:00:00-03:00' },
    'MOUSSE20': { coupon: 'MOUSSE20', name: 'The Facial Cleansing Mousse', ig: '', offer: '20% OFF', starts_at: '2026-08-17T00:00:00-03:00', expires_at: '2026-08-24T00:00:00-03:00' },
    'HYDRA20': { coupon: 'HYDRA20', name: 'The Hydra Water Gel', ig: '', offer: '20% OFF', starts_at: '2026-08-24T00:00:00-03:00', expires_at: '2026-08-31T00:00:00-03:00' },
    'VOLUME20': { coupon: 'VOLUME20', name: 'The Volume Shampoo', ig: '', offer: '20% OFF', starts_at: '2026-08-31T00:00:00-03:00', expires_at: '2026-09-07T00:00:00-03:00' },
    'SHAMPOO20': { coupon: 'SHAMPOO20', name: 'The Hydrating Shampoo', ig: '', offer: '20% OFF', starts_at: '2026-09-07T00:00:00-03:00', expires_at: '2026-09-14T00:00:00-03:00' },
    'CONDITIONER20': { coupon: 'CONDITIONER20', name: 'The Conditioner', ig: '', offer: '20% OFF', starts_at: '2026-09-14T00:00:00-03:00', expires_at: '2026-09-21T00:00:00-03:00' },
    'PROTECTOR20': { coupon: 'PROTECTOR20', name: 'The Leave-in Hair Protector', ig: '', offer: '20% OFF', starts_at: '2026-09-21T00:00:00-03:00', expires_at: '2026-09-28T00:00:00-03:00' },
    'REPAIR20': { coupon: 'REPAIR20', name: 'The Hair Repair Spray', ig: '', offer: '20% OFF', starts_at: '2026-09-28T00:00:00-03:00', expires_at: '2026-10-05T00:00:00-03:00' },
    'MASK20': { coupon: 'MASK20', name: 'The Repair Hair Mask', ig: '', offer: '20% OFF', starts_at: '2026-10-05T00:00:00-03:00', expires_at: '2026-10-12T00:00:00-03:00' },
    'OIL20': { coupon: 'OIL20', name: 'The Hair Oil', ig: '', offer: '20% OFF', starts_at: '2026-10-12T00:00:00-03:00', expires_at: '2026-10-19T00:00:00-03:00' },
    'CREAM20': { coupon: 'CREAM20', name: 'The Perfect Body Cream', ig: '', offer: '20% OFF', starts_at: '2026-10-19T00:00:00-03:00', expires_at: '2026-10-26T00:00:00-03:00' },
    'GLOW20': { coupon: 'GLOW20', name: 'The Sexy Glow Oil', ig: '', offer: '20% OFF', starts_at: '2026-10-26T00:00:00-03:00', expires_at: '2026-11-02T00:00:00-03:00' },
    'SCRUB20': { coupon: 'SCRUB20', name: 'The Touch Body Scrub', ig: '', offer: '20% OFF', starts_at: '2026-11-02T00:00:00-03:00', expires_at: '2026-11-09T00:00:00-03:00' },
    'SUMMER20': { coupon: 'SUMMER20', name: 'The Summer Affair', ig: '', offer: '20% OFF', starts_at: '2026-11-09T00:00:00-03:00', expires_at: '2026-11-16T00:00:00-03:00' },
    'LUCHETTI15': { coupon: 'LUCHETTI15', name: 'LUCHETTI', ig: '', offer: '20% OFF', starts_at: '2026-10-26T00:00:00-03:00', expires_at: '2026-11-02T00:00:00-03:00' },
    'FERGAIDARJI15': { coupon: 'FERGAIDARJI15', name: 'FERGAIDARJI', ig: '', offer: '20% OFF', starts_at: '2026-11-02T00:00:00-03:00', expires_at: '2026-11-09T00:00:00-03:00' },
    'MALUALVES15': { coupon: 'MALUALVES15', name: 'MALUALVES', ig: '', offer: '20% OFF', starts_at: '2026-11-09T00:00:00-03:00', expires_at: '2026-11-16T00:00:00-03:00' },
  };

  /* ── Utilitários de cookie ────────────────────────────────────────────── */
  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 86400000);
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value || '') + expires + '; path=/; SameSite=Lax; Secure';
  }

  function getCookie(name) {
    var nameEQ = name + '=';
    var parts = document.cookie.split(';');
    for (var i = 0; i < parts.length; i++) {
      var c = parts[i].replace(/^\s+/, '');
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length));
    }
    return null;
  }

  /* ── Persistência em localStorage ─────────────────────────────────────── */
  function saveInfluencer(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) { /* quota exceeded — ignora */ }
  }

  function loadInfluencer() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      // Verifica expiração (30 dias)
      if (data.expires && Date.now() > data.expires) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) { return null; }
  }

  /* ── Persistir UTMs para atribuição ────────────────────────────────────── */
  function setUtms(source, medium, campaign, content) {
    var params = new URLSearchParams();
    params.set('utm_source', source);
    params.set('utm_medium', medium);
    params.set('utm_campaign', campaign);
    if (content) params.set('utm_content', content);
    setCookie(UTM_COOKIE, params.toString(), COOKIE_DAYS);
  }

  function applyNativeDiscount(code) {
    if (!code) return Promise.resolve();

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ discount: code })
    }).then(function (response) {
      if (!response.ok) throw new Error('Falha ao aplicar cupom no carrinho.');
      return response.json();
    }).catch(function (error) {
      console.warn('[Theoric] Não foi possível aplicar o cupom da influenciadora.', error);
    });
  }

  /* ── Dispara evento para GA4 (via gtag direto) ─────────────────────── */
  function pushEvent(eventName, data) {
    if (typeof window.theoricLoadInfluencerGtag === 'function') {
      window.theoricLoadInfluencerGtag();
    }

    // gtag() direto — não precisa de GTM
    if (typeof gtag === 'function') {
      gtag('event', eventName, data);
    }
    // dataLayer como fallback (caso GTM esteja ativo)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, data));
  }

  /* ── Dispara evento para N8N ──────────────────────────────────────────── */
  function sendN8NEvent(eventType, meta) {
    var endpoint = 'https://theoric-n8n-webhook.ns2f8o.easypanel.host/webhook/events';
    var customerId = document.body.dataset.customerId || '';
    var sessionId = '';
    try {
      sessionId = window.ShopifyAnalytics && window.ShopifyAnalytics.lib
        ? window.ShopifyAnalytics.lib.user().traits().uniqToken || ''
        : '';
    } catch (e) { /* sem session */ }

    var payload = {
      event_type: eventType,
      customer_id: customerId,
      session_id: sessionId,
      location_path: window.location.pathname,
      metadata: meta,
      timestamp: new Date().toISOString()
    };

    if (navigator.sendBeacon) {
      navigator.sendBeacon(endpoint, JSON.stringify(payload));
    } else {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', endpoint, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify(payload));
    }
  }

  /* ── Banner de cupom ativo ────────────────────────────────────────────── */
  /* ── Controle de exibição do banner com cooldown ─────────────────────── */
  function getBannerState() {
    try {
      var raw = localStorage.getItem('theoric_banner_state');
      return raw ? JSON.parse(raw) : { show_count: 0, last_shown: 0 };
    } catch (e) { return { show_count: 0, last_shown: 0 }; }
  }

  function saveBannerState(state) {
    try { localStorage.setItem('theoric_banner_state', JSON.stringify(state)); } catch (e) { }
  }

  function shouldShowBanner(isLanding) {
    // Sempre mostra no landing (1a visita via ?ref=)
    if (isLanding) return true;

    var state = getBannerState();

    // Ainda não mostrou 2 vezes → mostra
    if (state.show_count < 2) return true;

    // Já mostrou 2+ vezes → respeita o cooldown
    var cooldownMs = BANNER_COOLDOWN_HOURS * 3600000;
    if (Date.now() - state.last_shown > cooldownMs) {
      // Cooldown passou — reseta contagem para mostrar de novo
      saveBannerState({ show_count: 0, last_shown: 0 });
      return true;
    }

    return false;
  }

  function markBannerShown() {
    var state = getBannerState();
    state.show_count = (state.show_count || 0) + 1;
    state.last_shown = Date.now();
    saveBannerState(state);
  }

  function dismissBanner(banner) {
    banner.style.transition = 'transform 0.4s ease, opacity 0.4s ease';
    banner.style.transform = 'translateY(100%)';
    banner.style.opacity = '0';
    setTimeout(function () { banner.remove(); }, 450);
    // Marca como mostrado ao dispensar também (evita reaparecer na mesma página)
    try { sessionStorage.setItem('theoric_banner_dismissed_page', '1'); } catch (e) { }
  }

  function showCouponBanner(coupon, offer) {
    if (document.getElementById('theoric-influencer-banner')) return;

    var offerText = offer || '';
    // Se não passou offer, tenta buscar do mapa
    if (!offerText) {
      var key = coupon.toUpperCase();
      if (INFLUENCER_MAP[key]) offerText = INFLUENCER_MAP[key].offer || '';
    }

    var banner = document.createElement('div');
    banner.id = 'theoric-influencer-banner';
    banner.setAttribute('style',
      'position:fixed;bottom:0;left:0;right:0;z-index:9998;' +
      'background:#5a4a42;color:#fff;text-align:center;' +
      'padding:12px 16px;font-family:Avantt,sans-serif;font-size:14px;' +
      'display:flex;align-items:center;justify-content:center;gap:10px;' +
      'transform:translateY(100%);opacity:0;' +
      'transition:transform 0.4s ease, opacity 0.4s ease;'
    );

    var offerBadge = offerText
      ? '<span style="' +
      'background:#fff;color:#5a4a42;font-weight:700;font-size:12px;' +
      'padding:3px 8px;border-radius:3px;letter-spacing:0.03em;' +
      'text-transform:uppercase;white-space:nowrap;' +
      '">' + offerText + '</span>'
      : '';

    banner.innerHTML =
      '<span>Cupom <strong>' + coupon + '</strong> ativado automaticamente</span>' +
      offerBadge +
      '<button id="theoric-influencer-banner-close" style="' +
      'background:none;border:none;color:#fff;font-size:18px;cursor:pointer;padding:0 4px;' +
      'line-height:1;margin-left:4px;">&times;</button>';

    document.body.appendChild(banner);

    // Registra que o banner foi exibido
    markBannerShown();

    // Animação de entrada
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        banner.style.transform = 'translateY(0)';
        banner.style.opacity = '1';
      });
    });

    // Auto-dismiss
    var autoTimer = setTimeout(function () { dismissBanner(banner); }, BANNER_DURATION);

    document.getElementById('theoric-influencer-banner-close').addEventListener('click', function () {
      clearTimeout(autoTimer);
      dismissBanner(banner);
    });
  }

  /* ══════════════════════════════════════════════════════════════════════
     MAIN — Executado no DOMContentLoaded
     ══════════════════════════════════════════════════════════════════════ */
  /* ── Ativa o cupom na sessão da Shopify (checkout nativo) ───────────────────
     Aplica o desconto silenciosamente tocando a rota nativa /discount/{code}.
     A Shopify registra o cupom no cookie de sessão do carrinho e ele permanece
     ATIVO até o checkout — o cliente não precisa digitar nada. Guardado por
     sessão (por código) para não repetir a requisição a cada page view. */
  function applyShopifyDiscount(code) {
    if (!code || typeof fetch !== 'function') return;
    var FLAG = 'theoric_discount_applied';
    try {
      if (sessionStorage.getItem(FLAG) === code) return;
    } catch (e) { }
    try {
      fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function () {
        try { sessionStorage.setItem(FLAG, code); } catch (e) { }
      }).catch(function () { });
    } catch (e) { }
  }

  function init() {
    var url = new URL(window.location.href);
    var refParam = (url.searchParams.get('ref') || '').trim().toUpperCase();
    var saved = loadInfluencer();

    /* ── 1. Novo acesso via link de influenciadora ──────────────────── */
    if (refParam && INFLUENCER_MAP[refParam]) {
      var info = INFLUENCER_MAP[refParam];

      // Respeita a janela de campanha quando o cupom e agendado.
      if (info.starts_at && Date.now() < new Date(info.starts_at).getTime()) {
        return; // Cupom ainda nao iniciou — nao ativa nada
      }

      if (info.expires_at && Date.now() > new Date(info.expires_at).getTime()) {
        return; // Cupom expirado — não ativa nada
      }

      var data = {
        code: refParam,
        coupon: info.coupon,
        name: info.name,
        ig: info.ig,
        offer: info.offer || '',
        landed_at: new Date().toISOString(),
        landing_page: window.location.pathname,
        expires: Date.now() + COOKIE_DAYS * 86400000
      };

      // Persistir para o checkout nativo Shopify
      saveInfluencer(data);
      setCookie(COUPON_COOKIE, info.coupon, COOKIE_DAYS);
      applyNativeDiscount(info.coupon);

      // Ativa o cupom na sessão da Shopify já no landing (checkout automático)
      applyShopifyDiscount(info.coupon);

      // Setar UTMs automaticamente
      setUtms('instagram', 'influencer', info.coupon.toLowerCase(), info.ig);

      // Evento GA4 / GTM
      pushEvent('influencer_landing', {
        influencer_code: refParam,
        influencer_name: info.name,
        coupon_code: info.coupon,
        landing_page: window.location.pathname
      });

      // Evento N8N
      sendN8NEvent('influencer_landing', {
        influencer_code: refParam,
        influencer_name: info.name,
        coupon_code: info.coupon,
        ig_handle: info.ig
      });

      // Limpar ?ref= da URL sem recarregar (mantém UTMs no histórico)
      if (window.history && window.history.replaceState) {
        url.searchParams.delete('ref');
        window.history.replaceState(null, '', url.toString());
      }

      // Mostrar banner no landing (sempre)
      showCouponBanner(data.coupon, data.offer || '');

      saved = data;
    }

    /* ── 2. Restaurar cupom de sessão anterior (persistência) ───────── */
    if (saved && saved.coupon) {
      // Reaplica o cupom ao carrinho nativo apenas quando a sessão precisa ser restaurada.
      var currentCoupon = getCookie(COUPON_COOKIE);
      if (!currentCoupon || currentCoupon !== saved.coupon) {
        setCookie(COUPON_COOKIE, saved.coupon, COOKIE_DAYS);
        applyNativeDiscount(saved.coupon);
      }

      // Garante que o cupom permaneça ativo na sessão da Shopify (1x por sessão)
      applyShopifyDiscount(saved.coupon);

      // Re-aplica UTMs se perdidas
      if (!getCookie(UTM_COOKIE)) {
        setUtms('instagram', 'influencer', saved.coupon.toLowerCase(), saved.ig || '');
      }

      // Mostrar banner em visitas de retorno (com cooldown inteligente)
      // Não mostra se já foi landing nesta execução (evita duplicar)
      if (!refParam) {
        var dismissedPage = false;
        try { dismissedPage = sessionStorage.getItem('theoric_banner_dismissed_page') === '1'; } catch (e) { }
        if (!dismissedPage && shouldShowBanner(false)) {
          showCouponBanner(saved.coupon, saved.offer || '');
        }
      }

      // Page view com contexto de influenciadora (para GA4)
      pushEvent('influencer_page_view', {
        influencer_code: saved.code,
        coupon_code: saved.coupon
      });
    }
  }

  /* ── Inicialização ────────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
